module.exports = __webpack_public_path__ + "static/media/ekoman.f36b1334.jpg";